module.exports = __webpack_public_path__ + "img/addPhoto.ae095dda.svg";